import type { Item } from '@finsim/model';
import { createEvent, sample } from 'effector';
import { commandIssued } from '../../entities/project';

/** An inspector edit: the whole next item plus the edited field (for undo coalescing). */
export const itemEdited = createEvent<{ item: Item; field: string }>();

sample({
  clock: itemEdited,
  fn: ({ item, field }) => ({
    command: { type: 'item/update' as const, item },
    coalesceKey: `${item.id}:${field}`,
  }),
  target: commandIssued,
});
